
import Vue from 'vue'
import orderManageApi from '@/api/orderManage/api.order'

const SETORDERDETAILS = 'SETORDERDETAILS';
const ORDERDETAILSCANCEL = 'ORDERDETAILSCANCEL';



// import '../../Mock/orderManageMock'


export default {
	state: {
		orderDetails: {},//订单详情
		giftBoxVoList: [],//礼盒列表

	},
	getters: {
		cancelStatus: state=> state.orderDetails.cancel ,//该订单是否可以取消 0-不可取消， 1-可以取消
		receiveTotalAmount: state=> state.orderDetails.receiveTotalAmount,//应收金额
		couponAmount: state=> state.orderDetails.totalCouponAmount,//券优惠金额
		payTotalAmount: state=> state.orderDetails.payTotalAmount,//支付金额
		createdTime: state=> state.orderDetails.createdTime,//下单时间
		status: state=> state.orderDetails.userOrderStatus,//订单状态
		statusDesc: state=> state.orderDetails.userOrderStatusDesc,//订单状态描述
		totalOrderAmount: state=> state.orderDetails.totalOrderAmount,//订单总金额描述
		merchantId:state=> state.orderDetails.merchantId,//	商户订单号	string	@mock=XF2017071213582463
	    payModesDesc: state=> state.orderDetails.payModesName,//	支付方式描述	string	@mock=在线支付
	    payModesId: state=> state.orderDetails.payModesId,//	支付id
	    payTime: state=> state.orderDetails.payTime,//	可支付时间
	    payNo: state=> state.orderDetails.payNo,//支付号
	    remarks: state=> state.orderDetails.remarks,//支付号
	    totalGoodsAmount: state=> state.orderDetails.totalGoodsAmount,//订单总金额
	    freightAmount: state=> state.orderDetails.freightAmount,//运费
	},
	actions: {
		getOrderDetails({commit},params){
			orderManageApi.getOrderDetails(params,function(res){
				var res = res.body;
				if(res.meta.code == '00000'){
					commit('SETORDERDETAILS',res.data)
				}
			})
		},
		signOrder({commit},params){
			return new Promise(function(resolve,reject){

				orderManageApi.signOrder(params,function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						resolve();
					}
				})

			})
		}
	},
	mutations:{
		SETORDERDETAILS(state, data){
			state.orderDetails = data;
			state.giftBoxVoList = data.merchantOrderDetailVos; 
		},
		ORDERDETAILSCANCEL(state){
			state.orderDetails.userOrderStatus = 0;
			state.giftBoxVoList.map(function(item){
				item.userOrderStatusDesc = '支付超时已取消';
	        	item.cancel = 0;
	        	item.userOrderStatus = 12;
			})
		},
		SESTINIT(state){
			state.orderDetails = {};
			state.giftBoxVoList =  [];
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/orderDetailsState.js